module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/haircut-mobile@2x-ec51d92d8fb23417c330dc288e67fbab.jpg";